import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Link, useParams } from 'react-router-dom'
import logoDark from '../../assets/images/vootkids.dark.svg'
import logo from '../../assets/images/login-logo.png'
import { TextField } from '../../components/styledFormElements/TextField'
import { twElementStyles } from '../../twElementStyles'
import { useState } from 'react'
import { Loader } from '../../components/loader'
import { useResetPassword } from '../../hooks/user'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
const schema = yup
    .object({
        email: yup.string().required(),
        newPassword: yup.string().required("Password is required"),
        cnewPassword: yup.string()
            .required('Password confirmation is mendatory')
            .oneOf([yup.ref('newPassword')], 'Passwords does not match'),
    })
    .required()
export const ResetPassword: React.FC<any> = (props) => {
    const params = useParams()
    const { mutate: resetPassword, isLoading, error } = useResetPassword()
    const errorMessage = error?.response?.data?.message
    const verifyKey = params.verifyKey
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
    })

    const [isDone, setIsDone] = useState(false)

    const handleResetPassword = (data: any) => {
        console.log('data,', data);
        resetPassword({
            data: {
                newPassword: data?.newPassword,
                email: data?.email,
                verifyKey: verifyKey
            }
        },
            {
                onSuccess(data, variables, context) {
                    setIsDone(true)
                }
            })
    }

    return (
        <div className="min-h-screen dark:bg-slate-700 bg-slate-200 flex flex-col flex-grow justify-center py-12 px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md mb-20">
                <div className=" py-10 px-8 rounded-lg bg-white dark:bg-slate-800 ">
                    <img src={logo} alt="logo" className="mb-4 my-5 h-20 mx-auto block dark:hidden" />
                    <img src={logo} alt="logo" className="mb-4 my-5 h-20 mx-auto hidden dark:block" />
                    {
                        isDone ?
                            <div className='items-center dark:text-white flex flex-col gap-3'>
                                <div className='flex gap-3 items-center'>
                                <CheckCircleIcon className='w-6 h-6 text-green-600' /> Password has been changed successfully !
                                </div>
                                <Link to={'/login'} className='underline font-semibold cursor-pointer'>Login</Link>
                            </div>
                            :
                            <form
                                autoComplete='off'
                                onSubmit={handleSubmit(handleResetPassword)}
                                className="mb-0 py-5"
                                noValidate
                            >
                                <div className="my-2">
                                    <TextField placeholder='Enter email :' type={'email'} autoFocus register={register('email')} errors={errors} label="Email:" />
                                </div>
                                <div className="my-2">
                                    <TextField autoComplete={'off'} placeholder='Enter new password :' type={'password'}  register={register('newPassword')} errors={errors} label="New Password:" />
                                </div>
                                <div className="my-2">
                                    <TextField autoComplete={'off'} placeholder='Re-enter new password' type={'password'} register={register('cnewPassword')} errors={errors} label="Confirm New Password:" />
                                </div>
                                <div className='w-full mt-5'>
                                    <button disabled={isLoading} type="submit" className={twElementStyles.twButtonPrimary + ' w-full py-3'} >
                                        {isLoading ? (
                                            <><Loader /> Please wait ...</>
                                        ) : 'Reset Password'}
                                    </button>
                                </div>
                                {errorMessage && <div className="my-2">
                                    <p className="dark:text-red-400 text-red-500 text-xs">
                                        {errorMessage}
                                    </p>
                                </div>}
                            </form>
                    }



                </div>
            </div>
        </div>
    )
}
